import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { SettingsProvider } from "./context/SettingsContext";
import Layout from "./components/app/Layout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Clients from "./pages/Clients";
import Quotes from "./pages/Quotes";
import QuoteEditor from "./pages/QuoteEditor";
import QuoteDetail from "./pages/QuoteDetail";
import Deadlines from "./pages/Deadlines";
import Users from "./pages/Users";
import PublicQuote from "./pages/PublicQuote";
import Settings from "./pages/Settings";
import Incassi from "./pages/Incassi";
import Spese from "./pages/Spese";
import Calendario from "./pages/Calendario";
import Catalogo from "./pages/Catalogo";
import Abbonamenti from "./pages/Abbonamenti";
import Documenti from "./pages/Documenti";
import PublicDocument from "./pages/PublicDocument";
import Email from "./pages/Email";
import AllegatiA from "./pages/AllegatiA";
import PublicAllegatoA from "./pages/PublicAllegatoA";
import InstallPWA from "./components/app/InstallPWA";
import "./App.css";

function Protected({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading) {
    return <div className="min-h-screen flex items-center justify-center text-sm text-[#64748B]">Caricamento…</div>;
  }
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <SettingsProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors closeButton />
          <InstallPWA />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/p/:token" element={<PublicQuote />} />
            <Route path="/d/:token" element={<PublicDocument />} />
            <Route path="/a/:token" element={<PublicAllegatoA />} />
            <Route element={<Protected><Layout /></Protected>}>
              <Route path="/" element={<Dashboard />} />
              <Route path="/clienti" element={<Clients />} />
              <Route path="/preventivi" element={<Quotes />} />
              <Route path="/preventivi/nuovo" element={<QuoteEditor />} />
              <Route path="/preventivi/:id" element={<QuoteDetail />} />
              <Route path="/preventivi/:id/modifica" element={<QuoteEditor />} />
              <Route path="/incassi" element={<Incassi />} />
              <Route path="/spese" element={<Spese />} />
              <Route path="/calendario" element={<Calendario />} />
              <Route path="/catalogo" element={<Protected roles={["amministratore", "super_admin"]}><Catalogo /></Protected>} />
              <Route path="/abbonamenti" element={<Protected roles={["amministratore", "super_admin"]}><Abbonamenti /></Protected>} />
              <Route path="/documenti" element={<Documenti />} />
              <Route path="/email" element={<Protected roles={["amministratore", "super_admin"]}><Email /></Protected>} />
              <Route path="/allegati-a" element={<Protected roles={["amministratore", "super_admin"]}><AllegatiA /></Protected>} />
              <Route path="/scadenze" element={<Deadlines />} />
              <Route path="/utenti" element={<Protected roles={["amministratore", "super_admin"]}><Users /></Protected>} />
              <Route path="/impostazioni" element={<Protected roles={["super_admin"]}><Settings /></Protected>} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </SettingsProvider>
    </AuthProvider>
  );
}

export default App;
